export default function Footer() {
  return (
    <footer className="bg-zinc-900 text-white border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6">
          <div className="text-center">
            <p className="text-sm text-zinc-400">
              © 2025 Creative Studio. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
